import React, { useRef, useState, useEffect } from "react";
import Header from "./Header";
import ReactPlayer from "react-player";

const LandingSection = ({ data }) => {
  const playerRef = useRef(null);
  const [utahTime, setUtahTime] = useState("");
  const [isClient, setIsClient] = useState(false);
  const [playerSize, setPlayerSize] = useState({ width: 0, height: 0 });
  const [videoReady, setVideoReady] = useState(false);
  const [hasLoopSeeked, setHasLoopSeeked] = useState(false);

  useEffect(() => {
    const updatePlayerSize = () => {
      const viewportWidth = window.innerWidth;
      const viewportHeight = window.innerHeight;
      const videoAspectRatio = 16 / 9;
      const viewportAspectRatio = viewportWidth / viewportHeight;

      if (viewportAspectRatio > videoAspectRatio) {
        setPlayerSize({
          width: viewportWidth + 4,
          height: viewportWidth / videoAspectRatio + 4,
        });
        return;
      }

      setPlayerSize({
        width: viewportHeight * videoAspectRatio + 4,
        height: viewportHeight + 4,
      });
    };
    updatePlayerSize();
    window.addEventListener("resize", updatePlayerSize);
    return () => window.removeEventListener("resize", updatePlayerSize);
  }, []);

  useEffect(() => {
    setIsClient(true);
    const updateTime = () => {
      const options = {
        timeZone: "America/Denver",
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      };
      const formatter = new Intl.DateTimeFormat("en-US", options);
      setUtahTime(formatter.format(new Date()));
    };
    updateTime();
    const interval = setInterval(updateTime, 1000);
    return () => clearInterval(interval);
  }, []);

  const backgroundContent =
    data || "https://www.youtube.com/watch?v=CPGNlE_pXzQ";

  const handleProgress = (state) => {
    if (!state.loadedSeconds || !state.playedSeconds) {
      return;
    }

    const secondsRemaining = state.loadedSeconds - state.playedSeconds;

    if (secondsRemaining <= 0.35 && !hasLoopSeeked) {
      playerRef.current?.seekTo(0, "seconds");
      setHasLoopSeeked(true);
      return;
    }

    if (secondsRemaining > 1) {
      setHasLoopSeeked(false);
    }
  };

  return (
    <div className="relative w-full min-h-screen h-screen overflow-hidden flex flex-col justify-between text-white">
      {/* Video or placeholder */}
      <div className="absolute inset-0 z-0">
        <img
          src="/img/placeholder1.webp"
          alt="Video background"
          className="w-full h-full object-cover"
        />

        {isClient && (
          <ReactPlayer
            ref={playerRef}
            url={backgroundContent}
            playing
            muted
            playbackRate={0.6}
            width={playerSize.width}
            height={playerSize.height}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              opacity: videoReady ? 1 : 0,
              pointerEvents: "none",
              transition: "opacity 400ms ease",
            }}
            playsinline
            onPlay={() => setVideoReady(true)}
            onProgress={handleProgress}
            config={{
              youtube: {
                playerVars: {
                  autoplay: 1,
                  controls: 0,
                  disablekb: 1,
                  fs: 0,
                  iv_load_policy: 3,
                  loop: 1,
                  modestbranding: 1,
                  playsinline: 1,
                  showinfo: 0,
                  rel: 0,
                },
              },
            }}
          />
        )}
      </div>

      <div className="absolute inset-0 z-1 bg-gradient-to-b from-black/70 via-black/35 to-black/75" />

      <div className="relative z-2">
        <Header />
      </div>

      <div
        className="flex justify-center mt-[27rem] relative"
        style={{ textShadow: "2px 2px 4px rgba(0,0,0,1)" }}
      ></div>

      <div
        className="relative -mt-[15rem] flex flex-col items-center justify-center text-center px-4 flex-1"
        style={{ textShadow: "2px 2px 4px rgba(0,0,0,1)" }}
      >
        <div className="text-white -mt-[8rem] sm:-mt-[0rem] text-lg sm:text-lg md:text-2xl lg:text-2xl text-center font-extrabold font-mono">
          {utahTime} MDT
        </div>
        <p className="text-[#facc15] text-base sm:text-xl font-bold">
          Welcome to UTahData.org
        </p>
        <h1 className="text-white text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-medium leading-tight">
          Explore Utah By The Numbers
        </h1>
      </div>
    </div>
  );
};

export default LandingSection;
